import { render, staticRenderFns } from "./DisplayCategoryInfo.vue?vue&type=template&id=3cc53eb3&"
import script from "./DisplayCategoryInfo.vue?vue&type=script&lang=ts&"
export * from "./DisplayCategoryInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports